module.exports = __webpack_public_path__ + "c4c97edbc4cc5929bd85dc4ec8b1151e.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/new-design/icons/applepay.svg
// module id = 1227
// module chunks = 65